import { useCallback } from 'react';

import { isDefined } from 'utils/tsHelpers';
import { insertInArray } from 'utils/helpers';
import { useCriteriaState } from './useCriteriaState';
import { useQueryCriteriasState } from '../query';
import { createBlankCriteria } from '../../utils/createBlankCriteria';
import { useQueryStateContext } from '../../contexts';
import { useCurrentCriteriaIndex } from './useCurrentCriteriaIndex';

export const useDuplicateCriteria = () => {
  const { criteria } = useCriteriaState();
  const { setToLatestId } = useQueryStateContext();
  const { setCriterias } = useQueryCriteriasState();
  const { combinator, searchQueries } = criteria;
  const index = useCurrentCriteriaIndex();

  return useCallback(() => {
    const newCriteria = createBlankCriteria({ combinator, searchQueries });
    setCriterias((criterias) => {
      if (!isDefined(index)) {
        return [...criterias, newCriteria];
      }
      return insertInArray([...criterias], index + 1, newCriteria);
    });
    setToLatestId(newCriteria.id);
  }, [setCriterias, combinator, searchQueries, setToLatestId]);
};
